import { render, staticRenderFns } from "./batch-session-update-modal.vue?vue&type=template&id=7671a616&scoped=true"
import script from "./batch-session-update-modal.vue?vue&type=script&lang=js"
export * from "./batch-session-update-modal.vue?vue&type=script&lang=js"
import style0 from "./batch-session-update-modal.vue?vue&type=style&index=0&id=7671a616&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671a616",
  null
  
)

export default component.exports